module.exports = __webpack_public_path__ + "static/media/graybox.ca3acbc0.svg";